import { GridColDef } from "@mui/x-data-grid-pro";
import ExecutionSheetModal from "Pages/Settings/ExecutionSheetModal";
import {
  DownloadIcon,
  GKButton,
  GKDataGrid,
  Grid2,
  SendIcon,
  Typography,
} from "components";
import dayjs from "dayjs";
import useGenerateQueryParams from "hooks/useGenerateQueryParams";
import { useFetchQuery } from "hooks/useQueries";
import DashboardLayout from "layouts/DashboardLayout";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { moneyCommaSeparatorPoint } from "utils/MathFunction";
import { TOTAL_ORDERS } from "utils/apiRoutes";
import { extraColumnsField } from "utils/helpers";
import useDocumentTitle from "utils/useDocumentTitle";
import OrderPopOverActions from "./OrderPopOverActions";

const TotalOrders = () => {
  useDocumentTitle("Basket Total Order");

  const [showSheetModal, setShowSheetModal] = useState(false);

  const navigate = useNavigate();

  const { id } = useParams();

  const requestBody = useGenerateQueryParams("totalOrders");

  const { data, isFetching } = useFetchQuery({
    key: ["ORDER_MANAGER_MERGED", requestBody],
    route: `/model_portfolio/order-manager-merged/`,
    requestBody,
  });

  const columns: GridColDef[] = [
    {
      ...extraColumnsField("Employee Name", "employeeName", 150, 1),
    },
    {
      ...extraColumnsField("Order Type", "orderType", 400, 1),
    },
    {
      ...extraColumnsField("Model Portfolio", "version", 150, 1),
      valueGetter: (param) => param?.row?.version || "-",
    },
    {
      ...extraColumnsField("Order Date & Time", "orderDate", 120, 1),
      renderCell: (params) => {
        return (
          <Typography display={"flex"} alignItems={"center"}>
            {dayjs(params?.row?.orderDate).format("DD MMM YYYY")}
            {", "}
            {dayjs(params?.row?.orderDate).format("hh:mm a")}
          </Typography>
        );
      },
    },
    {
      ...extraColumnsField("Portfolios", "numPortfolios", 100, 1),
      align: "right",
      headerAlign: "right",
      valueGetter: (param) => param?.row?.numPortfolios || "-",
      valueFormatter: (params) => moneyCommaSeparatorPoint(params.value),
    },
    {
      ...extraColumnsField("Actions", "action", 120, 1),
      align: "right",
      headerAlign: "right",
      renderCell: (params) => {
        return (
          <Grid2 container justifyContent={"flex-end"} gap={1} display={"flex"}>
            <OrderPopOverActions
              item={params.row}
              icon={<DownloadIcon width={20} height={20} />}
              type={["CSV", "ZIP"]}
            />
            <OrderPopOverActions
              item={params.row}
              icon={<SendIcon width={20} height={20} />}
              type={["TRADE", "ORDER"]}
            />
          </Grid2>
        );
      },
    },
  ];

  return (
    <DashboardLayout title="Total Orders">
      <Grid2 container>
        <Grid2 size={12}>
          <GKDataGrid
            loading={isFetching}
            columns={columns}
            rows={data?.data?.data || []}
            maxHeight={"calc(100vh - 264px)"}
            onRowClick={(params) => {
              navigate(
                `/app/equity-basket/${id}/order-manager/${params?.row?.id}/portfolios`,
                { state: { data: params?.row } },
              );
            }}
            totalCount={data?.data?.totalCount || 0}
            name="totalOrders"
            tableName="total_orders"
            exportFile={{
              path: TOTAL_ORDERS,
              exportName: "TotalOrders",
            }}
            headerComponent={
              <GKButton
                variant="contained"
                size="medium"
                onClick={() => {
                  setShowSheetModal(true);
                }}
              >
                Add Execution Sheet
              </GKButton>
            }
          />
        </Grid2>
      </Grid2>

      {showSheetModal && (
        <ExecutionSheetModal
          open={showSheetModal}
          setOpen={setShowSheetModal}
        />
      )}
    </DashboardLayout>
  );
};

export default TotalOrders;
